import type { ErrorMap } from '@/app/error-registry';

export const ONBOARDING_ERROR_MAP: ErrorMap = {
  POST: {
    conflict: 'organizations:apiErrors.onboardingConflict',
    default: 'organizations:apiErrors.onboardingDefault',
  },
};

export const ORG_AVATAR_ERROR_MAP: ErrorMap = {
  PATCH: {
    'Tenant.NotFound': 'organizations:apiErrors.notFound',
    'Tenant.Forbidden': 'organizations:apiErrors.forbidden',
    default: 'organizations:apiErrors.avatarUploadDefault',
  },
  DELETE: {
    'Tenant.NotFound': 'organizations:apiErrors.notFound',
    'Tenant.Forbidden': 'organizations:apiErrors.forbidden',
    default: 'organizations:apiErrors.avatarDeleteDefault',
  },
};

export const ORGANIZATIONS_ERROR_MAP: ErrorMap = {
  POST: {
    'Tenant.SlugAlreadyExists': 'organizations:apiErrors.slugAlreadyExists',
    'Tenant.InvalidTier': 'organizations:apiErrors.invalidTier',
    default: 'organizations:apiErrors.createDefault',
  },
  PUT: {
    'Tenant.NotFound': 'organizations:apiErrors.notFound',
    'Tenant.SlugAlreadyExists': 'organizations:apiErrors.slugAlreadyExists',
    'Tenant.InvalidTier': 'organizations:apiErrors.invalidTier',
    'Tenant.CannotDowngrade': 'organizations:apiErrors.cannotDowngrade',
    default: 'organizations:apiErrors.updateDefault',
  },
  DELETE: {
    'Tenant.NotFound': 'organizations:apiErrors.notFound',
    'Tenant.CannotDelete': 'organizations:apiErrors.cannotDelete',
    default: 'organizations:apiErrors.deleteDefault',
  },
};
